import React from 'react';
import { PlantPerformance } from '../../types';
import { UnifiedMetricCard } from '../ui/UnifiedMetricCard';

interface PlantPerformancePanelProps {
  performance: PlantPerformance | null;
  loading?: boolean;
}

const PlantPerformancePanel: React.FC<PlantPerformancePanelProps> = ({ 
  performance, 
  loading 
}) => {
  if (loading) {
    return (
      <div className="grid grid-cols-3 gap-4">
        {Array.from({ length: 9 }).map((_, i) => (
          <div key={i} className="bg-white dark:bg-gray-800 p-4 rounded-lg border">
            <div className="ai-skeleton h-4 w-16 mb-2"></div>
            <div className="ai-skeleton h-8 w-24"></div>
          </div>
        ))}
      </div>
    );
  }

  if (!performance) {
    return (
      <div className="text-center py-8 text-gray-500">
        No performance data available
      </div>
    );
  }

  const metrics = [
    { title: 'PR', value: performance.pr.toFixed(1), unit: '%', color: 'blue' as const },
    { title: 'CUF', value: performance.cuf.toFixed(1), unit: '%', color: 'green' as const },
    { title: 'Irradiation', value: performance.irradiation.toFixed(0), unit: 'W/m²', color: 'yellow' as const },
    { title: 'Energy', value: performance.energy_kwh.toLocaleString(), unit: 'kWh', color: 'purple' as const },
    { title: 'Active Power', value: performance.active_power_kw.toFixed(0), unit: 'kW', color: 'red' as const },
    { title: 'Grid Availability', value: performance.grid_availability.toFixed(1), unit: '%', color: 'indigo' as const },
    { title: 'Plant Availability', value: performance.plant_availability.toFixed(1), unit: '%', color: 'green' as const },
    { title: 'CO₂ Saved', value: performance.co2_saved.toFixed(2), unit: 'Tons', color: 'green' as const },
    { title: 'Trees Saved', value: performance.trees_saved, unit: '', color: 'green' as const },
  ];

  return (
    <div className="grid grid-cols-3 gap-4">
      {metrics.map((metric, index) => (
        <UnifiedMetricCard
          key={index}
          title={metric.title}
          value={metric.value}
          unit={metric.unit}
          color={metric.color}
        />
      ))}
    </div>
  );
};

export default PlantPerformancePanel;